import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'loyaltic-profile-codes',
  templateUrl: './profile-codes.component.html',
  styleUrls: ['./profile-codes.component.scss']
})
export class ProfileCodesComponent implements OnInit {
  @Input() codes: [];

  constructor() { }

  ngOnInit() {
  }

}
